<template>
  <section>
    <div
      class="p-6 mb-4 rounded my-8"
      :class="getBgClass(offer)"
      v-for="(offer, index) in offers"
      :key="index"
    >
      <div>
        <h4 class="flex items-center mb-1 fs-18">
          <svg width="32" height="32" class="mr-1 offer-discount-tag">
            <use xlink:href="/img/sprite.svg#ic_discount"></use>
          </svg>
          {{ offer.title }}
        </h4>
        <div class="standard-list my-4 list-reset" v-html="offer.text"></div>
        <div v-if="offer.blocked_from && offer.blocked_to" class="mb-2">
          <i>
            Offers not applicable from
            <time>{{ formatExpiryDate(offer.blocked_from) }}</time> to
            <time>{{ formatExpiryDate(offer.blocked_to) }}</time>
          </i>
        </div>

        <div
          v-if="offer.travel_until && getDaysLeft(offer.travel_until)"
          class="font-bold my-2 fs-16"
        >
          {{ getDaysLeft(offer.travel_until) }}
        </div>

        <span v-if="offer.travel_from && offer.travel_until" class="fs-16">
          Travel from
          <time>{{ formatExpiryDate(offer.travel_from) }}</time> until
          <time>{{ formatExpiryDate(offer.travel_until) }}</time>
        </span>
        <span v-else-if="offer.travel_until" class="fs-16">
          Travel until
          <time>{{ formatExpiryDate(offer.travel_until) }}</time>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import { mapState } from "vuex";

export default {
  props: ["supplierId"],
  computed: {
    ...mapState(["offers"]),
  },
  mounted() {
    const url = `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/suppliers/${this.supplierId}/special_offers`;

    axios
      .get(url)
      .then((response) => {
        if (response.data.length) {
          const result = orderBy(
            response.data,
            ["travel_until", "expired_at"],
            ["asc", "asc"]
          ).slice(0, 2);

          this.$store.commit("setOffers", result);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  },
  methods: {
    formatExpiryDate(dateString) {
      return moment(dateString, "YYYY-MM-DD").format("DD MMM YYYY");
    },
    getBgClass(offer) {
      const suffix = get(offer, ["offerColor", "value"], "purplePrimary");

      return `offer-bg--${suffix}`;
    },
    getDaysLeft(date) {
      const diff = moment(date).diff(moment(), "days", true);
      if (diff > 30) {
        return null;
      } else if (diff < 0) {
        return "Offer ends today";
      }

      const d = Math.ceil(diff);
      const time = d === 1 ? "1 day" : `${d} days`;
      return `Offer ends in ${time}`;
    },
  },
};
</script>
